/* eslint-disable standard/no-callback-literal */


function get(token, path, callback) {
  var req = new XMLHttpRequest()
  req.withCredentials = true
  req.open('GET', process.env.VUE_APP_API_URL + path)
  req.setRequestHeader('authorization', token)
  req.addEventListener('load', function (event) {
    if (req.status !== 200) {
      callback(false)
    } else {
      callback(JSON.parse(req.responseText))
    }
  })
  req.onerror = (event) => {
    callback(false)
  }
  req.send()
}

function getWithStatus(path, callback) {
  var req = new XMLHttpRequest()
  req.withCredentials = true
  req.open('GET', process.env.VUE_APP_API_URL + path)
  req.onload = (event) => {
    if (req.status !== 200) {
      try {
        callback(req.status, JSON.parse(req.responseText))
      } catch (e) {
        callback(req.status, req.responseText)
      }
    } else {
      try {
        callback(req.status, JSON.parse(req.responseText))
      } catch (e) {
        callback(req.status, req.responseText)
      }
    }
  }
  req.onerror = (event) => {
    callback(req.status, req.responseText)
  }
  req.send()
}
function deleteWithStatus(path, callback) {
  var req = new XMLHttpRequest()
  req.withCredentials = true
  req.open('DELETE', process.env.VUE_APP_API_URL + path)
  req.addEventListener('load', function (event) {
    if (req.status !== 200) {
      try {
        callback(req.status, JSON.parse(req.responseText))
      } catch (e) {
        callback(req.status, req.responseText)
      }
    } else {
      try {
        callback(req.status, JSON.parse(req.responseText))
      } catch (e) {
        callback(req.status, req.responseText)
      }
    }
  })
  req.send()
}
function postWithStatus(path, data, callback, token) {
  var req = new XMLHttpRequest()
  req.withCredentials = true
  req.open('POST', process.env.VUE_APP_API_URL + path)
  req.setRequestHeader('content-type', 'application/json')
  if (token) {
    req.setRequestHeader('authorization', token)
  }
  req.addEventListener('load', function (event) {
    if (req.status !== 200) {
      callback(req.status, req.responseText)
    } else {
      try {
        callback(req.status, JSON.parse(req.responseText))
      } catch (e) {
        callback(req.status, req.responseText)
      }
    }
  })
  req.send(JSON.stringify(data))
}

function postFormData(path, formData, callback) {
  var req = new XMLHttpRequest()
  req.withCredentials = true
  req.open('POST', process.env.VUE_APP_API_URL + path)
  // Don't set content-type header - browser will set it with boundary for multipart/form-data
  req.addEventListener('load', function (event) {
    if (req.status !== 200 && req.status !== 201) {
      callback(req.status, req.responseText)
    } else {
      try {
        callback(req.status, JSON.parse(req.responseText))
      } catch (e) {
        callback(req.status, req.responseText)
      }
    }
  })
  req.send(formData)
}

function putWithStatus(path, data, callback) {
  var req = new XMLHttpRequest()
  req.withCredentials = true
  req.open('PUT', process.env.VUE_APP_API_URL + path)
  req.setRequestHeader('content-type', 'application/json')
  req.addEventListener('load', function (event) {
    if (req.status !== 200) {
      callback(req.status, req.responseText)
    } else {
      try {
        callback(req.status, JSON.parse(req.responseText))
      } catch (e) {
        callback(req.status, req.responseText)
      }
    }
  })
  req.send(JSON.stringify(data))
}

function post(token, path, data, callback) {
  var req = new XMLHttpRequest()
  req.withCredentials = true
  req.open('POST', process.env.VUE_APP_API_URL + path)
  req.setRequestHeader('content-type', 'application/json')
  req.setRequestHeader('authorization', token)
  req.addEventListener('load', function (event) {
    if (req.status !== 200) {
      callback(false)
    } else {
      try {
        callback(JSON.parse(req.responseText))
      } catch (e) {
        callback(false)
      }
    }
  })
  req.onerror = () => {
    callback(false)
  }
  req.send(JSON.stringify(data))
}
function httpDelete(token, path, data, callback) {
  var req = new XMLHttpRequest()
  req.withCredentials = true
  req.open('DELETE', process.env.VUE_APP_API_URL + path)
  req.setRequestHeader('content-type', 'application/json')
  req.setRequestHeader('authorization', token)
  req.addEventListener('load', function (event) {
    if (req.status !== 200) {
      callback(false)
    } else {
      try {
        callback(JSON.parse(req.responseText))
      } catch (e) {
        callback(false)
      }
    }
  })
  req.send(JSON.stringify(data))
}
function put(token, path, data, callback) {
  var req = new XMLHttpRequest()
  req.withCredentials = true
  req.open('PUT', process.env.VUE_APP_API_URL + path)
  req.setRequestHeader('content-type', 'application/json')
  req.setRequestHeader('authorization', token)
  req.addEventListener('load', function (event) {
    if (req.status !== 200) {
      callback(false)
    } else {
      try {
        callback(JSON.parse(req.responseText))
      } catch (e) {
        callback(req.responseText)
      }
    }
  })
  req.send(JSON.stringify(data))
}

function getAllJobs(token, callback) {
  get(token, '/jobs', callback)
}

function getJobsInGroup(token, groupId, callback) {
  get(token, '/jobs/groups/' + groupId, callback)
}
function getChats(token, callback) {
  get(token, '/chats', callback)
}

function getChatContacts(token, callback) {
  get(token, '/chats/contacts', callback)
}

function getArchive(token, callback) {
  get(token, '/jobs/archive', callback)
}
function getJobById(token, id, callback) {
  get(token, '/jobs/' + id, callback)
}
function createChat(token, content, callback) {
  post(token, '/chats', content, callback)
}
function getChatById(token, id, callback) {
  get(token, '/chats/' + id, callback)
}

function sendMessageInChat(token, id, message, callback) {
  postWithStatus('/chats/' + id, {
    message: message
  }, (s, r) => {
    callback(s == 201)
  })
}

function setAttendance(token, id, von, bis, callback) {
  putWithStatus('/jobs/' + id, {
    Von_Uhrzeit: von,
    Bis_Uhrzeit: bis
  }, callback)
}

function isAuthenticated(token, callback) {
  getWithStatus('/rest/auth/authenticate', (s, r) => {
    callback(s == 200)
  })
}

function acceptJob(token, id, callback) {
  getWithStatus('/jobs/' + id + '/accept', callback)
}

function acceptJobGroup(token, groupid, callback) {
  getWithStatus('/jobs/groups/' + groupid + '/accept', callback)
}

function declineJob(token, id, callback) {
  getWithStatus('/jobs/' + id + '/decline', callback)
}

function confirmJob(token, id, callback) {
  getWithStatus('/jobs/' + id + '/confirm', callback)
}

function getStats(callback) {
  getWithStatus("/stats", (status, resp) => {
    if (status == 200 && localStorage) {
      localStorage.setItem("stats", JSON.stringify(resp));
    }
    callback(status, resp)
  })
}

function getUser(token, callback) {
  getWithStatus('/user/', callback)
}

function getAdminUser(token, persnr, callback) {
  getWithStatus('/rest/users/?persnr=' + persnr, callback)
}

function getFiles(token, callback) {
  getWithStatus('/assets/', callback)
}

function getFile(id, callback) {
  getFileOTL(id, (s, r) => {
    if (s == 200) {
      var req = new XMLHttpRequest()
      req.withCredentials = true
      req.open('GET', process.env.VUE_APP_API_URL + r.link)
      req.responseType = 'arraybuffer';
      req.addEventListener('load', function (event) {
        if (req.status == 200) {
          callback(req.response, req.getResponseHeader("content-type"))
        }
      })
      req.send()
    } else {
      callback(s, r)
    }
  })

}

function getFileOTL(id, callback) {
  getWithStatus('/assets/otl/' + id, callback)
}

function generateLoginCode(token, callback) {
  get(token, "/rest/auth/loginCode", callback)
}
function getProjects(token, callback) {
  get(token, "/rest/projects", callback)
}

function requestSMS(token, filter, type, callback) {
  filter.type = type
  post(token, "/rest/jobs/sms", filter, callback)
}

function getAdminJobs(token, filter, callback) {
  const params = new URLSearchParams();
  Object.entries(filter || {}).forEach(([key, value]) => {
    if (value === '' || value === null || value === undefined) return;
    if (typeof value === 'object') {
      if (!Array.isArray(value) && Object.keys(value).length === 0) return;
      value = JSON.stringify(value);
    }
    params.set(key, String(value));
  });
  const query = params.toString();
  get(token, "/rest/adminjobs" + (query ? "?" + query : ""), callback)
}
function getPlanJobs(token, filter, callback) {
  queryurl = "?"
  k = Object.keys(filter)
  for (i = 0; i < k.length; i++) {
    if (queryurl != "?") queryurl += "&"
    queryurl += k[i] + "=" + filter[k[i]]
  }
  if (filter.project) {
    get(token, "/rest/planjobs" + queryurl, callback)
  } else {
    get(token, "/rest/allplanjobs" + queryurl, callback)
  }
}

function getAllUsers(callback) {
  get("", "/rest/users?all=true", callback)
}
function getAdminEmployees(filter = {}, callback) {
  const params = new URLSearchParams({
    all: "true",
    employeeTable: "true"
  })
  if (filter.active !== undefined && filter.active !== null) {
    params.set("active", String(filter.active))
  }
  if (filter.search) params.set("search", filter.search)
  if (filter.columnFilters && Object.keys(filter.columnFilters).length) {
    params.set("columnFilters", JSON.stringify(filter.columnFilters))
  }
  getWithStatus("/rest/users?" + params.toString(), callback)
}
function getUsers(token, callback) {
  get(token, "/rest/users", callback)
}
function getUsersWithFilter(filter, callback) {
  let query = "";
  Object.keys(filter).forEach(key => {
    query += key + "=" + filter[key] + "&"
  })
  get("", "/rest/users?" + query,callback)
}
function getPicture(token, user, callback) {
  get(token, "/rest/users/" + user.id + "/picture", callback)
}
function getPresets(token, callback) {
  get(token, "/rest/presets", callback)
}
function getSpots(token, location, callback) {
  get(token, "/rest/locations/" + location + "/spots", callback)
}
function getCAs(token, callback) {
  get(token, "/rest/companies", callback)
}
function changeUser(token, userId, changes, callback) {
  put(token, "/rest/users/" + userId, changes, callback)
}
function changeUserWithStatus(userId, changes, callback) {
  putWithStatus("/rest/users/" + userId, changes, callback)
}
function getNextPersnr(firmenkuerzel, callback) {
  getWithStatus("/rest/users/next-persnr?firmenkuerzel=" + encodeURIComponent(firmenkuerzel), callback)
}
function approveEmployee(userId, callback) {
  postWithStatus("/rest/users/" + userId + "/approve", {}, callback)
}
function getEinsatzortBlocks(userId, callback) {
  getWithStatus("/rest/users/" + userId + "/einsatzort-blocks", callback)
}
function createEinsatzortBlock(userId, data, callback) {
  postWithStatus("/rest/users/" + userId + "/einsatzort-blocks", data, callback)
}
function deleteEinsatzortBlock(blockId, callback) {
  deleteWithStatus("/rest/users/einsatzort-blocks/" + blockId, callback)
}

function sendInvitation(token, userId, callback) {
  post(token, "/rest/users/sms", { type: "invitation", user: userId }, callback)
}

function changeJob(token, jobId, changes, callback) {
  put(token, "/rest/adminjobs/" + jobId, changes, callback)
}
function createJob(token, job, callback) {
  post(token, "/rest/adminjobs", job, callback)
}
function sendCheckinReport(token, filter, mail, callback) {
  post(token, "/rest/checkins/sendReport", {
    filter: filter,
    mail: mail
  }, callback)
}
function savePicture(token, user, image, callback) {
  put(token, "/rest/users/" + user.id + "/picture", image, callback)
}
function checkLoginCode(code, callback) {
  post("", "/rest/auth/loginCode", { code: code }, callback)
}
function getCheckinJobs(token, callback) {
  get(token, "/rest/checkins", callback)
}
function getMessageGroups(token, callback) {
  get(token, "/admin/messagegroups", callback)
}
function checkInJob(token, jobId, callback) {
  post(token, "/rest/checkins", { jobId: jobId }, callback)
}
function saveMessageGroup(token, group, callback) {
  post(token, "/admin/messagegroups", group, callback)
}
function sendMessageToGroup(token, group, message, callback) {
  post(token, "/admin/messagegroups/" + group.id + "/send", message, callback)
}
function sendMessageToGroupViaApp(token, group, message, callback) {
  post(token, "/admin/messagegroups/" + group.id + "/sendapp", message, callback)
}
function deleteMessageGroup(token, group, callback) {
  httpDelete(token, "/admin/messagegroups/" + group.id, {}, callback)
}
function getDocumentUsers(contract, location, cb) {
  getWithStatus("/rest/admin/docs/users?contract=" + contract + "&location=" + location, cb)
}

function isOnline(cb) {
  getWithStatus("/ping", (status, res) => {
    cb(status == 200)
  })
}

function updateDocumentUser(permission, cb) {
  if (permission.user.id == -1) {
    postWithStatus("/rest/admin/docs/users", permission, cb)
  } else {
    putWithStatus("/rest/admin/docs/users/" + permission.user.id, permission, cb)
  }
}

function requestMailCode(mail, cb) {
  postWithStatus("/rest/auth/mailcode", { mail: mail, requestId: generateRequestId(mail) }, cb)
}

function deleteExternalDocumentPermission(permission, cb) {
  deleteWithStatus("/rest/admin/docs/users/permission/" + permission.id, cb)
}

function checkMailCode(code, cb) {
  postWithStatus("/rest/auth/mailcode/redeem", { code: code }, cb)
}

function getOpenDocuments(cb) {
  getWithStatus("/rest/admin/docs", cb)
}

function getJobsForExternalUsers(date, cb) {
  if (date) {
    getWithStatus("/external/jobs?date=" + date, cb)
  } else {
    getWithStatus("/external/jobs", cb)
  }
}

function getJobDocumentsForUser(cb) {
  getWithStatus("/docs", cb)
}

function getSameJobs(job, cb) {
  getWithStatus("/docs/sameJobs?jobid=" + job.id, cb)
}

function getSignaturesForJob(job, cb) {
  getWithStatus("/docs/" + job.id + "/signatures", cb)
}

function updateLocation(contract, location, body, cb) {
  putWithStatus("/rest/admin/docs/" + contract + "/" + location, body, cb)
}

function addRoute(data, cb) {
  postWithStatus("/routes", data, cb)
}

function updateRoute(id, data, cb) {
  putWithStatus("/routes/" + id, data, cb)
}

function getRoute(id, cb) {
  getWithStatus("/routes/" + id, cb)
}

function getJobsWithTours(place, cb) {
  getWithStatus("/routes/place/" + place + "/jobs", cb)
}

function getLastScansForExternalUsers(cb) {
  getWithStatus("/external/scans", cb)
}

function addTour(data, cb) {
  postWithStatus("/routes/" + data.route + "/tours", data, cb)
}

function updateTour(data, cb) {
  putWithStatus("/routes/" + data.route + "/tours/" + data.index, data, cb)
}

function getTour(id, cb) {
  getWithStatus("/routes/tours/" + id, cb)
}
function downloadTour(id, cb) {
  getWithStatus("/routes/tours/" + id + "/download", cb)

}
function addWaypointscan(wps, cb) {
  postWithStatus("/routes/" + wps.route + "/tours/" + wps.tourIndex + "/waypoints", wps, cb)
}

function getRoutesForPlace(placeCode, cb) {
  getWithStatus("/routes?placeCode=" + placeCode, cb)
}

function getRoutesForJob(jobId, cb) {
  getWithStatus("/routes?job=" + jobId, cb)
}

function getAdminOTL(cb) {
  getWithStatus("/assets/otl/admin", cb)
}

function saveJobDocument(job, type, document, docId, cb) {
  if (docId) {
    putWithStatus("/docs/document/" + docId, {
      document: document,
      type: type
    }, cb)
  } else {
    postWithStatus("/docs/" + job.id, {
      document: document,
      type: type
    }, cb)
  }
}

function deleteJobDocument(id, cb) {
  deleteWithStatus("/docs/document/" + id, cb)
}

function getJobDocuments(job, cb) {
  getWithStatus("/docs/" + job.id, cb)
}

function getJobDocument(id, cb) {
  getWithStatus("/docs/document/" + id, cb)
}
function logoutWeb(cb) {
  postWithStatus("/rest/auth/logoutWeb", {}, cb)
}
function impersonateUser(userId, token, cb) {
  postWithStatus("/rest/auth/impersonate", { userId: userId }, cb, token)
}
function stopImpersonation(token, cb) {
  postWithStatus("/rest/auth/impersonation/stop", {}, cb, token)
}

function getLocationInfo(contract, location, date, cb) {
  getWithStatus("/rest/admin/docs/" + contract + "/" + location + "?date=" + date, cb)
}

function signDocument(id, type, signature, passed, cb) {
  postWithStatus("/docs/document/" + id + "/sign", {
    type: type,
    path: signature,
    passedExternal: passed
  }, cb)
}

function checkSignature(id, type, cb) {
  getWithStatus("/docs/document/" + id + "/sign?type=" + type, cb)
}

function getPreviousDocumentEntries(place, type, cb) {
  getWithStatus("/docs/previousEntries?place=" + place + "&type=" + type, cb)
}

function getTasks(status, cb) {
  getWithStatus("/tasks/?status=" + status, cb)
}
function getTask(id, cb) {
  getWithStatus("/tasks/" + id, cb)
}

function getTaskContacts(cb) {
  getWithStatus("/tasks/contacts", cb)
}

function getTaskFiles(task, cb) {
  getWithStatus("/tasks/" + task.id + "/files", cb)
}
function addTaskFile(task, file, cb) {
  postWithStatus("/tasks/" + task.id + "/files", file, cb)
}

function getTaskComments(task, cb) {
  getWithStatus("/tasks/" + task.id + "/comments", cb)
}

function addTaskComment(task, comment, cb) {
  postWithStatus("/tasks/" + task.id + "/comments", {
    comment: comment
  }, cb)
}

function createTask(task, cb) {
  postWithStatus("/tasks", task, cb)
}
function deleteTask(taskId, cb) {
  deleteWithStatus("/tasks/" + taskId, cb)
}
function updateTask(task, cb) {
  putWithStatus("/tasks/" + task.id, task, cb)
}

function updateWaypointscan(wps, cb) {
  putWithStatus("/routes/waypointscans/" + wps.id, wps, cb)
}

function getUser(userId, cb) {
  getWithStatus("/rest/users/" + userId, cb)
}
function updateUser(userId, user, cb) {
  putWithStatus("/rest/users/" + userId, user, cb)
}
function createUser(user, cb) {
  postWithStatus("/rest/users", user, cb)
}

function exportOrdnungsamt(cb) {
  getWithStatus("/rest/users/export/ordnungsamt", cb)
}

function getMeldeliste(cb) {
  getWithStatus("/rest/users/meldeliste", cb)
}

function getMeldelisteSettings(cb) {
  getWithStatus("/rest/meldeliste/settings", cb)
}

function saveMeldelisteSettings(settings, cb) {
  putWithStatus("/rest/meldeliste/settings", settings, cb)
}

function getMeldelisteFilterOptions(cb) {
  getWithStatus("/rest/users/meldeliste/filter-options", cb)
}

function getMeldelisteUsersByJobs(params, cb) {
  const query = new URLSearchParams(params).toString();
  getWithStatus("/rest/users/meldeliste/by-jobs?" + query, cb)
}

function getViewSettings(cb) {
  getWithStatus("/rest/viewsettings", cb)
}

function saveViewSettings(view, settings, cb) {
  putWithStatus("/rest/viewsettings/" + encodeURIComponent(view), settings, cb || function () {})
}

function exportDatevForUser(userId, month, cb) {
  getWithStatus("/rest/users/" + userId + "/datev-export/" + encodeURIComponent(month), cb)
}

function exportDatevForAll(month, cb) {
  getWithStatus("/rest/users/datev-export/" + encodeURIComponent(month), cb)
}

function uploadLohnabrechnungen(file, month, preview, cb) {
  var formData = new FormData()
  formData.append('document', file)
  formData.append('month', month)
  formData.append('preview', preview ? 'true' : 'false')
  postFormData('/rest/lohnabrechnungen', formData, cb)
}

function getAccessCodes(filters, cb) {
  const params = new URLSearchParams(filters).toString()
  getWithStatus("/rest/accesscodes" + (params ? "?" + params : ""), cb)
}

function createAccessCode(code, cb) {
  postWithStatus("/rest/accesscodes", code, cb)
}

function updateAccessCode(id, code, cb) {
  putWithStatus("/rest/accesscodes/" + id, code, cb)
}

function deleteAccessCode(id, cb) {
  deleteWithStatus("/rest/accesscodes/" + id, cb)
}

function getParkingTickets(filters, cb) {
  const params = new URLSearchParams(filters).toString()
  getWithStatus("/rest/parkingtickets" + (params ? "?" + params : ""), cb)
}

function createParkingTicket(ticket, cb) {
  // Check if ticket is FormData (file upload) or regular object
  if (ticket instanceof FormData) {
    postFormData("/rest/parkingtickets", ticket, cb)
  } else {
    postWithStatus("/rest/parkingtickets", ticket, cb)
  }
}

function updateParkingTicket(id, ticket, cb) {
  putWithStatus("/rest/parkingtickets/" + id, ticket, cb)
}

function deleteParkingTicket(id, cb) {
  deleteWithStatus("/rest/parkingtickets/" + id, cb)
}

function getParkingTicket(id, cb) {
  getWithStatus("/rest/parkingtickets/" + id, cb)
}

function addUserDocument(userId, document, cb) {
  document.belongsTo = userId;
  postWithStatus("/assets/userdocuments", document, cb)
}

function deleteUserDocument(documentId, cb) {
  deleteWithStatus("/assets/userdocuments/" + documentId, cb)
}

function getMetabaseDashboardUrl(type, id, cb) {
  const queryParams = new URLSearchParams()
  if (type) queryParams.append('type', type)
  if (id) queryParams.append('id', id)
  const queryString = queryParams.toString()
  getWithStatus("/metabase/dashboard-url" + (queryString ? "?" + queryString : ""), cb)
}

module.exports = {
  calculateVacationHours: calculateVacationHours,
  getVacationOverview: getVacationOverview,
  getVacationOverviewForUser: getVacationOverviewForUser,
  addUserDocument: addUserDocument,
  deleteUserDocument: deleteUserDocument,
  getUser: getUser,
  updateUser: updateUser,
  createUser: createUser,
  exportOrdnungsamt: exportOrdnungsamt,
  getMeldeliste: getMeldeliste,
  getMeldelisteSettings: getMeldelisteSettings,
  saveMeldelisteSettings: saveMeldelisteSettings,
  getMeldelisteFilterOptions: getMeldelisteFilterOptions,
  getMeldelisteUsersByJobs: getMeldelisteUsersByJobs,
  getViewSettings: getViewSettings,
  saveViewSettings: saveViewSettings,
  exportDatevForUser: exportDatevForUser,
  exportDatevForAll: exportDatevForAll,
  uploadLohnabrechnungen: uploadLohnabrechnungen,
  getAccessCodes: getAccessCodes,
  createAccessCode: createAccessCode,
  updateAccessCode: updateAccessCode,
  deleteAccessCode: deleteAccessCode,
  getParkingTickets: getParkingTickets,
  createParkingTicket: createParkingTicket,
  updateParkingTicket: updateParkingTicket,
  deleteParkingTicket: deleteParkingTicket,
  getParkingTicket: getParkingTicket,
  getLastScansForExternalUsers: getLastScansForExternalUsers,
  getPreviousDocumentEntries: getPreviousDocumentEntries,
  addTaskFile: addTaskFile,
  getPlanJobs: getPlanJobs,
  checkInJob: checkInJob,
  getMessageGroups: getMessageGroups,
  getCheckinJobs: getCheckinJobs,
  deleteMessageGroup: deleteMessageGroup,
  sendMessageToGroup: sendMessageToGroup,
  sendMessageToGroupViaApp: sendMessageToGroupViaApp,
  changeJob: changeJob,
  changeUser: changeUser,
  sendInvitation: sendInvitation,
  sendCheckinReport: sendCheckinReport,
  getCAs: getCAs,
  getPicture: getPicture,
  saveMessageGroup: saveMessageGroup,
  getPresets: getPresets,
  getSpots: getSpots,
  savePicture: savePicture,
  getUsers: getUsers,
  getUsersWithFilter:getUsersWithFilter,
  getAllUsers: getAllUsers,
  getAdminEmployees: getAdminEmployees,
  getAdminJobs: getAdminJobs,
  getProjects: getProjects,
  checkLoginCode: checkLoginCode,
  generateLoginCode: generateLoginCode,
  arrayBufferToBase64: arrayBufferToBase64,
  getAllJobs: getAllJobs,
  getJobsInGroup: getJobsInGroup,
  getChats: getChats,
  getArchive: getArchive,
  sendMessageInChat: sendMessageInChat,
  getJobById: getJobById,
  getChatContacts: getChatContacts,
  createJob: createJob,
  requestSMS: requestSMS,
  setAttendance: setAttendance,
  createChat: createChat,
  getChatById: getChatById,
  isAuthenticated: isAuthenticated,
  acceptJob: acceptJob,
  acceptJobGroup: acceptJobGroup,
  declineJob: declineJob,
  getStats: getStats,
  getUser: getUser,
  getAdminUser: getAdminUser,
  getFileOTL: getFileOTL,
  getFile: getFile,
  getFiles: getFiles,
  confirmJob: confirmJob,
  getDocumentUsers: getDocumentUsers,
  updateDocumentUser: updateDocumentUser,
  deleteExternalDocumentPermission: deleteExternalDocumentPermission,
  requestMailCode: requestMailCode,
  checkMailCode: checkMailCode,
  getOpenDocuments: getOpenDocuments,
  getJobsForExternalUsers: getJobsForExternalUsers,
  getSameJobs: getSameJobs,
  getSignaturesForJob: getSignaturesForJob,
  saveJobDocument: saveJobDocument,
  deleteJobDocument: deleteJobDocument,
  getJobDocuments: getJobDocuments,
  getJobDocument: getJobDocument,
  signDocument: signDocument,
  getJobDocumentsForUser: getJobDocumentsForUser,
  logoutWeb: logoutWeb,
  impersonateUser: impersonateUser,
  stopImpersonation: stopImpersonation,
  getLocationInfo: getLocationInfo,
  updateLocation: updateLocation,
  checkSignature: checkSignature,
  getTasks: getTasks,
  getTaskContacts: getTaskContacts,
  createTask: createTask,
  deleteTask: deleteTask,
  checkTemplatePlaceholders: checkTemplatePlaceholders,
  getTask: getTask,
  updateTask: updateTask,
  getTaskComments: getTaskComments,
  addTaskComment: addTaskComment,
  getTaskFiles: getTaskFiles,
  getRoute: getRoute,
  getTour: getTour,
  getJobsWithTours: getJobsWithTours,
  addRoute: addRoute,
  addTour: addTour,
  addWaypointscan: addWaypointscan,
  updateRoute: updateRoute,
  getRoutesForPlace: getRoutesForPlace,
  getRoutesForJob: getRoutesForJob,
  isOnline: isOnline,
  updateWaypointscan: updateWaypointscan,
  downloadTour: downloadTour,
  updateTour: updateTour,
  getAdminOTL: getAdminOTL,
  uploadTemplate: uploadTemplate,
  listTemplates: listTemplates,
  generateFileFromTemplate: generateFileFromTemplate,
  getOriginalTemplate: getOriginalTemplate,
  createXlsxFromCsv: createXlsxFromCsv,
  deleteTemplate: deleteTemplate,
  addMaterial: addMaterial,
  updateMaterial: updateMaterial,
  deleteMaterial: deleteMaterial,
  getCoreData: getCoreData,
  addCoreData: addCoreData,
  updateCoreData: updateCoreData,
  deleteCoreData: deleteCoreData,
  getHolidays: getHolidays,
  seedHolidays: seedHolidays,
  getTrainings: getTrainings,
  addTraining: addTraining,
  updateTraining: updateTraining,
  deleteTraining: deleteTraining,
  deleteTrainingExecution: deleteTrainingExecution,
  executeTraining: executeTraining,
  changeUserWithStatus: changeUserWithStatus,
  getNextPersnr: getNextPersnr,
  approveEmployee: approveEmployee,
  getEinsatzortBlocks: getEinsatzortBlocks,
  createEinsatzortBlock: createEinsatzortBlock,
  deleteEinsatzortBlock: deleteEinsatzortBlock,
  getEquipment: getEquipment,
  getMetabaseDashboardUrl: getMetabaseDashboardUrl,
  getTarife: getTarife,
  getSubtarife: getSubtarife,
  getVertragsbeschreibungen: getVertragsbeschreibungen,
  createBasistarif: createBasistarif,
  updateBasistarif: updateBasistarif,
  deleteBasistarif: deleteBasistarif,
  createVerrechnungstarif: createVerrechnungstarif,
  updateVerrechnungstarif: updateVerrechnungstarif,
  deleteVerrechnungstarif: deleteVerrechnungstarif,
  copyVerrechnungstarif: copyVerrechnungstarif,
  createSubtarif: createSubtarif,
  updateSubtarif: updateSubtarif,
  deleteSubtarif: deleteSubtarif,
  copySubtarif: copySubtarif,
  getVertraege: getVertraege,
  getVertrag: getVertrag,
  getContractBillingData: getContractBillingData,
  createVertrag: createVertrag,
  updateVertrag: updateVertrag,
  deleteVertrag: deleteVertrag,
  getTimeAccount: getTimeAccount,
  updateTimeAccountStartBalance: updateTimeAccountStartBalance,
  calculateTimeAccount: calculateTimeAccount,
  reopenTimeAccount: reopenTimeAccount,
  refreshTimeAccount: refreshTimeAccount,
  getKontakte: getKontakte,
  createKontakt: createKontakt,
  updateKontakt: updateKontakt,
  deleteKontakt: deleteKontakt,
  createKontaktpunkt: createKontaktpunkt,
  updateKontaktpunkt: updateKontaktpunkt,
  deleteKontaktpunkt: deleteKontaktpunkt,
  getKontaktDocuments: getKontaktDocuments,
  uploadKontaktDocument: uploadKontaktDocument,
  downloadKontaktDocument: downloadKontaktDocument,
  deleteKontaktDocument: deleteKontaktDocument,
  createEinsatzort: createEinsatzort,
  updateEinsatzort: updateEinsatzort,
  deleteEinsatzort: deleteEinsatzort,
  createEinsatzstelle: createEinsatzstelle,
  updateEinsatzstelle: updateEinsatzstelle,
  deleteEinsatzstelle: deleteEinsatzstelle,
  getInvoiceJobs: getInvoiceJobs,
  previewInvoice: previewInvoice,
  billSelectedJobs: billSelectedJobs,
  createInvoice: createInvoice,
  generateInvoicePDF: generateInvoicePDF,
  getInvoicePDF: getInvoicePDF,
  getInvoices: getInvoices,
  updateInvoiceStatus: updateInvoiceStatus,
  deleteInvoice: deleteInvoice,
  getRechnungspruefungSubunternehmer: getRechnungspruefungSubunternehmer,
  getRechnungspruefungVertraege: getRechnungspruefungVertraege,
  previewRechnungspruefung: previewRechnungspruefung,
  deleteJobToTrash: deleteJobToTrash,
  getTrashcanEntries: getTrashcanEntries,
  deleteTrashcanEntry: deleteTrashcanEntry,
  debugLogin: debugLogin,
}

function generateRequestId(message) {
  let hashValue = 0
  for (let i = 0; i < message.length; i++) {
    let charCode = message.charCodeAt(i);
    hashValue = ((hashValue << 5) - hashValue) + charCode;
    hashValue = hashValue & hashValue; // Ensure 32-bit integer limit
  }

  hashValue = hashValue >>> 0; // Convert to unsigned 32-bit integer
  return hashValue.toString(16).padStart(8, '0');
}

function arrayBufferToBase64(arrayBuffer) {
  var base64 = "";
  var encodings =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

  var bytes = new Uint8Array(arrayBuffer);
  var byteLength = bytes.byteLength;
  var byteRemainder = byteLength % 3;
  var mainLength = byteLength - byteRemainder;

  var a, b, c, d;
  var chunk;

  for (var i = 0; i < mainLength; i = i + 3) {
    chunk = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];

    a = (chunk & 16515072) >> 18;
    b = (chunk & 258048) >> 12;
    c = (chunk & 4032) >> 6;
    d = chunk & 63;

    base64 += encodings[a] + encodings[b] + encodings[c] + encodings[d];
  }

  if (byteRemainder == 1) {
    chunk = bytes[mainLength];

    a = (chunk & 252) >> 2;

    b = (chunk & 3) << 4;

    base64 += encodings[a] + encodings[b] + "==";
  } else if (byteRemainder == 2) {
    chunk = (bytes[mainLength] << 8) | bytes[mainLength + 1];

    a = (chunk & 64512) >> 10;
    b = (chunk & 1008) >> 4;

    c = (chunk & 15) << 2;

    base64 += encodings[a] + encodings[b] + encodings[c] + "=";
  }

  return base64;
}

// Lists all templates
function listTemplates(callback) {
  getWithStatus("/opm/templates", callback)
}

function checkTemplatePlaceholders(file, callback) {
  postWithStatus("/opm/templates/check", { file: file }, callback)
}

function getTrainings(callback) {
  getWithStatus("/trainings", callback)
}

function addTraining(training, callback) {
  postWithStatus("/trainings", training, callback)
}

function updateTraining(training, callback) {
  putWithStatus("/trainings/" + training.id, training, callback)
}

function deleteTraining(trainingId, callback) {
  deleteWithStatus("/trainings/" + trainingId, callback)
}

function deleteTrainingExecution(executionId, callback) {
  deleteWithStatus("/trainings/executions/" + executionId, callback)
}

function executeTraining(trainingId, data, callback) {
  postWithStatus("/trainings/" + trainingId + "/execute", data, callback)
}

function addMaterial(userId, material, callback) {
  postWithStatus("/user/" + userId + "/material", material, callback);
}

function getCoreData(callback) {
  getWithStatus("/admin/data/", callback)
}

function getEquipment(callback) {
  getWithStatus("/admin/data/equipment", callback)
}

function updateCoreData(type, id, data, callback) {
  putWithStatus("/admin/data/" + type + "/" + id, data, callback)
}

function addCoreData(type, data, callback) {
  postWithStatus("/admin/data/" + type, data, callback)
}

function deleteCoreData(type, id, callback) {
  deleteWithStatus("/admin/data/" + type + "/" + id, callback)
}

function getHolidays(callback) {
  getWithStatus("/admin/data/holidays", callback)
}

function seedHolidays(callback) {
  postWithStatus("/admin/data/holidays/seed", {}, callback)
}

function updateMaterial(material, callback) {
  putWithStatus(`/user/material/${material.id}`, material, callback);
}

function deleteMaterial(materialId, callback) {
  deleteWithStatus(`/user/material/${materialId}`, callback);
}


// Generates a file from a template and values
function generateFileFromTemplate(templateId, options, values, callback) {
  postWithStatus("/opm/templates/" + templateId + "/generate", { options: options, placeholderValues: values }, callback)
}

function createXlsxFromCsv(csv, callback) {
  postWithStatus("/opm/csv2xlsx", { csv: csv }, callback)
}

function getOriginalTemplate(templateId, callback) {
  getWithStatus("/opm/templates/" + templateId + "/file", callback)
}

function deleteTemplate(templateId, callback) {
  deleteWithStatus("/opm/templates/" + templateId, callback)
}
// Uploads a template DOCX file to /opm/templates
function uploadTemplate(file, templateName, purpose, callback) {
  postWithStatus("/opm/templates", {
    fileData: file,
    name: templateName,
    purpose: purpose
  }, callback)
}

function getTarife(callback) {
  getWithStatus("/admin/tarife", callback)
}

function getSubtarife(callback) {
  getWithStatus("/admin/tarife/subtarife", callback)
}

function getVertragsbeschreibungen(callback) {
  getWithStatus("/admin/tarife/vertragsbeschreibungen", callback)
}

function createBasistarif(data, callback) {
  postWithStatus("/admin/tarife/basistarife", data, callback)
}

function updateBasistarif(id, data, callback) {
  putWithStatus("/admin/tarife/basistarife/" + id, data, callback)
}

function deleteBasistarif(id, callback) {
  deleteWithStatus("/admin/tarife/basistarife/" + id, callback)
}

function createVerrechnungstarif(data, callback) {
  postWithStatus("/admin/tarife/verrechnungstarife", data, callback)
}

function updateVerrechnungstarif(id, data, callback) {
  putWithStatus("/admin/tarife/verrechnungstarife/" + id, data, callback)
}

function deleteVerrechnungstarif(id, callback) {
  deleteWithStatus("/admin/tarife/verrechnungstarife/" + id, callback)
}

function copyVerrechnungstarif(id, data, callback) {
  postWithStatus("/admin/tarife/verrechnungstarife/" + id + "/copy", data, callback)
}

function createSubtarif(data, callback) {
  postWithStatus("/admin/tarife/subtarife", data, callback)
}

function updateSubtarif(id, data, callback) {
  putWithStatus("/admin/tarife/subtarife/" + id, data, callback)
}

function deleteSubtarif(id, callback) {
  deleteWithStatus("/admin/tarife/subtarife/" + id, callback)
}

function copySubtarif(id, data, callback) {
  postWithStatus("/admin/tarife/subtarife/" + id + "/copy", data, callback)
}

function getVertraege(callback) {
  getWithStatus("/admin/vertraege", callback)
}

function getVertrag(id, callback) {
  getWithStatus("/admin/vertraege/" + id, callback)
}

function getContractBillingData(contractId, month, year, callback) {
  getWithStatus(`/admin/vertraege/${contractId}/billing?month=${month}&year=${year}`, callback)
}

function createVertrag(data, callback) {
  postWithStatus("/admin/vertraege", data, callback)
}

function updateVertrag(id, data, callback) {
  putWithStatus("/admin/vertraege/" + id, data, callback)
}

function deleteVertrag(id, callback) {
  deleteWithStatus("/admin/vertraege/" + id, callback)
}

function createEinsatzort(contractId, data, callback) {
  postWithStatus("/admin/vertraege/" + contractId + "/einsatzorte", data, callback)
}

function updateEinsatzort(contractId, einsatzortId, data, callback) {
  putWithStatus("/admin/vertraege/" + contractId + "/einsatzorte/" + einsatzortId, data, callback)
}

function deleteEinsatzort(contractId, einsatzortId, callback) {
  deleteWithStatus("/admin/vertraege/" + contractId + "/einsatzorte/" + einsatzortId, callback)
}

function createEinsatzstelle(contractId, einsatzortId, data, callback) {
  postWithStatus("/admin/vertraege/" + contractId + "/einsatzorte/" + einsatzortId + "/einsatzstellen", data, callback)
}

function updateEinsatzstelle(contractId, einsatzortId, einsatzstelleId, data, callback) {
  putWithStatus("/admin/vertraege/" + contractId + "/einsatzorte/" + einsatzortId + "/einsatzstellen/" + einsatzstelleId, data, callback)
}

function deleteEinsatzstelle(contractId, einsatzortId, einsatzstelleId, callback) {
  deleteWithStatus("/admin/vertraege/" + contractId + "/einsatzorte/" + einsatzortId + "/einsatzstellen/" + einsatzstelleId, callback)
}

function getTimeAccount(userId, month, callback) {
  getWithStatus("/rest/users/" + userId + "/timeaccount/" + month, callback)
}

function updateTimeAccountStartBalance(userId, month, startBalance, manualCorrection, callback) {
  putWithStatus("/rest/users/" + userId + "/timeaccount/" + month, { startBalance, manualCorrection }, callback)
}

function calculateTimeAccount(userId, month, confirmOrCallback, callback) {
  const confirm = typeof confirmOrCallback === 'boolean' ? confirmOrCallback : false
  const resultCallback = typeof confirmOrCallback === 'function' ? confirmOrCallback : callback
  postWithStatus("/rest/users/" + userId + "/timeaccount/" + month + "/calculate", { confirm }, resultCallback)
}

function reopenTimeAccount(userId, month, reason, confirm, callback) {
  postWithStatus("/rest/users/" + userId + "/timeaccount/" + month + "/reopen", { reason, confirm }, callback)
}

function refreshTimeAccount(userId, month, reason, confirm, expectedUpdatedAt, callback) {
  postWithStatus("/rest/users/" + userId + "/timeaccount/" + month + "/refresh",
    { reason, confirm, expectedUpdatedAt }, callback)
}

function getKontakte(type, search, callback) {
  let params = new URLSearchParams()
  if (type) params.append('type', type)
  if (search) params.append('search', search)
  const query = params.toString() ? '?' + params.toString() : ''
  getWithStatus("/admin/kontakte" + query, callback)
}

function createKontakt(data, callback) {
  postWithStatus("/admin/kontakte", data, callback)
}

function updateKontakt(id, data, callback) {
  putWithStatus("/admin/kontakte/" + id, data, callback)
}

function deleteKontakt(id, callback) {
  deleteWithStatus("/admin/kontakte/" + id, callback)
}

function deleteInvoice(id, callback) {
  deleteWithStatus("/admin/invoices/" + id, callback)
}

function debugLogin(password, callback) {
  postWithStatus("/rest/auth/debug", { password: password }, callback)
}

function createKontaktpunkt(kontaktId, data, callback) {
  postWithStatus("/admin/kontakte/" + kontaktId + "/kontaktpunkte", data, callback)
}

function updateKontaktpunkt(kontaktId, kontaktpunktId, data, callback) {
  putWithStatus("/admin/kontakte/" + kontaktId + "/kontaktpunkte/" + kontaktpunktId, data, callback)
}

function deleteKontaktpunkt(kontaktId, kontaktpunktId, callback) {
  deleteWithStatus("/admin/kontakte/" + kontaktId + "/kontaktpunkte/" + kontaktpunktId, callback)
}

function getKontaktDocuments(kontaktId, callback) {
  getWithStatus("/admin/kontakte/" + kontaktId + "/documents", callback)
}

function uploadKontaktDocument(kontaktId, file, callback) {
  var formData = new FormData()
  formData.append('document', file)

  var req = new XMLHttpRequest()
  req.withCredentials = true
  req.open('POST', process.env.VUE_APP_API_URL + "/admin/kontakte/" + kontaktId + "/documents")

  req.upload.addEventListener('progress', function (event) {
    if (event.lengthComputable) {
      var percentComplete = (event.loaded / event.total) * 100
    }
  })

  req.addEventListener('load', function (event) {
    if (req.status !== 200) {
      try {
        var errorData = JSON.parse(req.responseText)
        callback(req.status, errorData.error || req.responseText)
      } catch (e) {
        callback(req.status, req.responseText)
      }
    } else {
      try {
        callback(req.status, JSON.parse(req.responseText))
      } catch (e) {
        callback(req.status, req.responseText)
      }
    }
  })

  req.addEventListener('error', function (event) {
    console.error('Upload network error')
    callback(0, 'Netzwerkfehler beim Hochladen')
  })

  req.addEventListener('abort', function (event) {
    console.error('Upload aborted')
    callback(0, 'Upload wurde abgebrochen')
  })

  req.send(formData)
}

function calculateVacationHours(jobId, callback) {
  postWithStatus(`/rest/vacation/calculate/${jobId}`, {}, callback);
}

function getVacationOverview(callback) {
  getWithStatus("/rest/vacation/overview", callback);
}

function getVacationOverviewForUser(userId, month, callback) {
  var path = "/rest/vacation/overview/" + userId;
  if (month) path += "?month=" + month;
  getWithStatus(path, callback);
}

function downloadKontaktDocument(kontaktId, documentId) {
  window.open(process.env.VUE_APP_API_URL + "/admin/kontakte/" + kontaktId + "/documents/" + documentId, '_blank')
}

function deleteKontaktDocument(kontaktId, documentId, callback) {
  deleteWithStatus("/admin/kontakte/" + kontaktId + "/documents/" + documentId, callback)
}

// Invoice functions
function getInvoiceJobs(contractId, startDate, endDate, skipBilled, callback) {
  let params = new URLSearchParams()
  params.append('contract_id', contractId)
  if (startDate) params.append('start_date', startDate)
  if (endDate) params.append('end_date', endDate)
  if (skipBilled) params.append('skip_billed', skipBilled)
  getWithStatus("/admin/invoices/jobs?" + params.toString(), callback)
}

function previewInvoice(jobIds, callback) {
  postWithStatus("/admin/invoices/preview", { job_ids: jobIds }, callback)
}

function billSelectedJobs(jobIds, callback){
  postWithStatus("/admin/invoices/bill", { job_ids: jobIds }, callback)
}

function createInvoice(jobIds, invoiceData, callback) {
  postWithStatus("/admin/invoices", { job_ids: jobIds, invoice_data: invoiceData }, callback)
}

function generateInvoicePDF(invoiceId, callback) {
  postWithStatus("/admin/invoices/" + invoiceId + "/pdf", {}, callback)
}

function getInvoicePDF(invoiceId) {
  window.open(process.env.VUE_APP_API_URL + "/admin/invoices/" + invoiceId + "/pdf", '_blank')
}

function getInvoices(callback) {
  getWithStatus("/admin/invoices", callback)
}

function updateInvoiceStatus(invoiceId, status, callback) {
  putWithStatus("/admin/invoices/" + invoiceId + "/status", { status: status }, callback)
}

function deleteInvoice(invoiceId, callback) {
  deleteWithStatus("/admin/invoices/" + invoiceId, callback)
}

// Rechnungsprüfung (Subunternehmer-Abrechnungsvorschau)
function getRechnungspruefungSubunternehmer(callback) {
  getWithStatus("/admin/rechnungspruefung/subunternehmer", callback)
}

function getRechnungspruefungVertraege(kontaktId, von, bis, callback) {
  let params = new URLSearchParams()
  params.append('kontaktId', kontaktId)
  params.append('von', von)
  params.append('bis', bis)
  getWithStatus("/admin/rechnungspruefung/vertraege?" + params.toString(), callback)
}

function previewRechnungspruefung(kontaktId, von, bis, vertragsbeschreibungen, callback) {
  postWithStatus("/admin/rechnungspruefung/preview", {
    kontaktId: kontaktId,
    von: von,
    bis: bis,
    vertragsbeschreibungen: vertragsbeschreibungen
  }, callback)
}

function deleteJobToTrash(token, jobId, callback) {
  var req = new XMLHttpRequest()
  req.withCredentials = true
  req.open('DELETE', process.env.VUE_APP_API_URL + '/rest/adminjobs/' + jobId)
  req.setRequestHeader('content-type', 'application/json')
  req.setRequestHeader('authorization', token)
  req.addEventListener('load', function (event) {
    if (req.status !== 200) {
      try {
        callback(req.status, JSON.parse(req.responseText))
      } catch (e) {
        callback(req.status, req.responseText)
      }
    } else {
      try {
        callback(req.status, JSON.parse(req.responseText))
      } catch (e) {
        callback(req.status, req.responseText)
      }
    }
  })
  req.send()
}

function getTrashcanEntries(token, callback) {
  get(token, '/rest/admin/jobs/trash', callback)
}

function deleteTrashcanEntry(token, entryId, callback) {
  var req = new XMLHttpRequest()
  req.withCredentials = true
  req.open('DELETE', process.env.VUE_APP_API_URL + '/rest/trashcan/' + entryId)
  req.setRequestHeader('content-type', 'application/json')
  req.setRequestHeader('authorization', token)
  req.addEventListener('load', function (event) {
    if (req.status !== 200) {
      try {
        callback(req.status, JSON.parse(req.responseText))
      } catch (e) {
        callback(req.status, req.responseText)
      }
    } else {
      try {
        callback(req.status, JSON.parse(req.responseText))
      } catch (e) {
        callback(req.status, req.responseText)
      }
    }
  })
  req.send()
}